import { FaXTwitter, FaBluesky, FaLink, FaFacebook } from 'react-icons/fa6'
import * as Sentry from '@sentry/react'
import type { IconType } from 'react-icons'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import useSession from '@/hooks/useSession'
import useOnboarding from '@/hooks/useOnboarding'
import { getContributionURL } from '@/util/helpers'

export default function SocialSection() {
  const { t } = useTranslation()
  const { session } = useSession()
  const { isOnboarding } = useOnboarding()
  const schoolSlug = session?.schoolSlug ?? ''
  const parentSlug = session?.parentSlug ?? ''

  const text = t('content.components.social_share.share_text')

  // const instagramLink = 'https://www.instagram.com/'
  // const instagramShareLink = `${shareUrl}&request_type=instagram`
  const blueskyLink = `https://bsky.app/intent/compose?text=${encodeURIComponent(
    `${text} ${getContributionURL(schoolSlug, parentSlug, 'bluesky')}`
  )}`
  const fbLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    `${getContributionURL(schoolSlug, parentSlug, 'facebook')}`
  )}`
  const xLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    `${text} ${getContributionURL(schoolSlug, parentSlug, 'twitter')}`
  )}`
  const clipboardLink = getContributionURL(schoolSlug, parentSlug, 'copy')

  const handleCopyToClipboard = async (link: string) => {
    try {
      await navigator.clipboard.writeText(link)
      toast.success(t('content.components.social_share.copy_success_toast'))
    } catch (error) {
      Sentry.logger.error('Failed to copy link to clipboard', { error: String(error) })
      toast.error(t('content.components.social_share.copy_error_toast'))
    }
  }
  if (isOnboarding) {
    return null
  }

  return (
    <div className='bg-cta text-center px-4 md:px-8 pt-8 pb-2'>
      <h1 className='text-white text-xl font-serif text-center mb-2'>{t('content.components.social_share.title')}</h1>
      <div className='flex flex-row gap-x-2 justify-center'>
        {/* Instagram sharing is functionality TBD */}
        {/* <SocialIcon
          icon={FaInstagram}
          onClick={async () => {
            await handleCopyToClipboard(instagramShareLink)
            await new Promise((resolve) => setTimeout(resolve, 1000))
            window.open(instagramLink, '_blank')
          }}
        /> */}
        <SocialIcon icon={FaBluesky} onClick={() => window.open(blueskyLink, '_blank')} />
        <SocialIcon icon={FaXTwitter} onClick={() => window.open(xLink, '_blank')} />
        <SocialIcon icon={FaFacebook} onClick={() => window.open(fbLink, '_blank')} />
        <SocialIcon
          icon={FaLink}
          text={t('content.components.social_share.copy_link')}
          onClick={() => handleCopyToClipboard(clipboardLink)}
        />
      </div>
    </div>
  )
}

const SocialIcon = (props: { icon: IconType; text?: string; onClick?: () => void }) => {
  return (
    <div
      className='group bg-white hover:bg-neutral-200 p-1 rounded-lg flex items-center gap-x-1 cursor-pointer font-semibold'
      onClick={props.onClick}
      role={props.onClick ? 'button' : undefined}
    >
      <props.icon className='text-black w-7 h-7 shrink-0 group-hover:text-cta group-active:text-cta' />
      {props.text && (
        <span className='text-black text-sm whitespace-nowrap group-hover:text-cta group-active:text-cta'>
          {props.text}
        </span>
      )}
    </div>
  )
}
